import { render, staticRenderFns } from "./SqlQuery.vue?vue&type=template&id=2f15163a&scoped=true"
import script from "./SqlQuery.vue?vue&type=script&lang=js"
export * from "./SqlQuery.vue?vue&type=script&lang=js"
import style0 from "./SqlQuery.vue?vue&type=style&index=0&id=2f15163a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f15163a",
  null
  
)

export default component.exports